import http from "../utils/http-common";

const baseHistoryPath = "api/fugitive-history";

export const getOptionsFilter = (query: string) => {
  return http.get(`${baseHistoryPath}/options/filter-fugitive-logs?${query}`);
};

export const getHistory = (query: string) => {
  return http.get(`${baseHistoryPath}?${query}`);
};
